// import TypingEffect from "../../../../utils/TypingEffect";
import s from "./StartSearch.module.css";
import { useAuth} from 'contexts/AuthContext'
const StartSearch = () => {
    const { user } = useAuth();

    return ( 
<div className={s.startSearch}>
    <div>
        <img className={s.startSearchLogo} src="/logo.png" alt="Logo" />
    </div>
    {user ? (
        <div className={s.title}>Welcome, {user.user_metadata.firstName}.</div>
    ) : (
        <div className={s.title}>Welcome to Quadratik.AI</div>
    )}
    
    <div className={s.subtitle}>Start your search by applying any filters in the filter panel.</div>
    <div className={s.divider}></div>
    <div className={s.socialProofTitle}>Trusted by leading GTM, VC, PE, & SaaS firms</div>
    <div className={s.logos}>
        <img src="big-life-marketing-logo.png" alt="" />
        <img src="client-acquisition-ai-logo.png" alt="" />
        <img src="go-ventures-logo.png" alt="" />
        <img src="hyros-logo.png" alt="" />
        <img src="lemonlight-logo.png" alt="" />
        <img src="royal-legal-solutions-logo.png" alt="" />
    </div>
</div>
     );
}
 
export default StartSearch;